/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CountDetailsDataModel {
    getFixupPrototypeFunction() { return CountDetailsDataModel.fixupPrototype; }

    static newInstance(model: Partial<CountDetailsDataModel>): CountDetailsDataModel {
        let obj = Object.assign(new CountDetailsDataModel(), model);
        CountDetailsDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CountDetailsDataModel>): CountDetailsDataModel {
        if (!model) return null;
        return CountDetailsDataModel.newInstance(<CountDetailsDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CountDetailsDataModel) {
        if (!obj) return;

        models.CountDetailsDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CountDetailsDataModel): boolean {
        Object.setPrototypeOf(obj, CountDetailsDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_account) {
            for (let val of this.cloud_account) {
                models.CloudAccountDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Id's for the cloud account
     */
    cloud_account: Array<models.CloudAccountDetail>;

    /**
     * Cloud service name
     */
    service: models.CloudServiceName;

    /**
     * Default value [by default: false] If default = true, displays count only for that particular default_resource/default_category  If default = false, displays count for all the category/resource except that mentioned in default_resource/default_category.
     */
    default_value: boolean = false;

    /**
     * Category value [by default: Compute]  Give this value if the value of identifier is resource. Displays all the resources for the particular category provided.
     */
    category: string;

    /**
     * Default resource [by default: based upon Category] Give this value if the value of identifier is resource. Displays count for resource.
     */
    default_resource: string;

    /**
     * Default category [by default: Compute]  Give this value if the value of identifier is category. Displays count for category.
     */
    default_category: string;

}
